<form #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate>
    <div class="modal-header">
    <h5 class="modal-title">{{ title | slice:0:1 | uppercase }}{{ title | slice:1 }}</h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Fermer"></button>
  </div>
  <div class="modal-body">
    <div class="row">


    <!-- Reservation -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Reservation</label>
      <select
        class="form-select"
        [disabled]="itemToSave.id"
        name="reservation_id"
        [(ngModel)]="itemToSave.reservation_id"
        required
        #reservation="ngModel"
        (change)="onSelectReservation()"
      >
        <option *ngFor="let item of itemsReservation" [value]="item.id">
          {{ item.client_nom }} {{ item.client_prenom }} ({{ item.client_telephone }})
        </option>
      </select>
      <div class="text-danger" *ngIf="reservation.invalid && reservation.touched">
        Reservation est requis
      </div>
    </div>

    <!-- Service -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Service</label>
      <select
        class="form-select"
        disabled
        name="service_id"
        [(ngModel)]="itemToSave.service_id"
        required
        #service="ngModel"
        (change)="onGetChambreDisponible(); onSetHeure(); calculatePrice()"
      >
        <option *ngFor="let item of itemsService" [value]="item.id">{{ item.libelle }}</option>
      </select>
      <div class="text-danger" *ngIf="service.invalid && service.touched">
        Service est requis
      </div>
    </div>

    <!-- Début date -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Début</label>
      <input
        type="date"
        class="form-control"
        disabled
        [ngModel]="itemToSave.date_debut | date: 'yyyy-MM-dd'"
        name="date_debut"
        #date_debutCtrl="ngModel"
        required
        (change)="onGetChambreDisponible(); onSetHeure(); calculatePrice()"
      />
      <div class="text-danger" *ngIf="date_debutCtrl.invalid && date_debutCtrl.touched">
        Date début est requise
      </div>
    </div>

    <!-- Heure début -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Heure début</label>
      <input
        type="time"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.heure_debut"
        name="heure_debut"
        #heure_debutCtrl="ngModel"
      />
      <div class="text-danger" *ngIf="heure_debutCtrl.invalid && heure_debutCtrl.touched">
        Heure début est requise
      </div>
    </div>

    <!-- Fin date -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Fin</label>
      <input
        type="date"
        class="form-control"
        disabled
        [ngModel]="itemToSave.date_fin | date: 'yyyy-MM-dd'"
        name="fin_reservation"
        #fin_reservationCtrl="ngModel"
        required
        (change)="onGetChambreDisponible(); calculatePrice()"
      />
      <div class="text-danger" *ngIf="fin_reservationCtrl.invalid && fin_reservationCtrl.touched">
        Date fin est requise
      </div>
    </div>

    <!-- Heure fin -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Heure fin</label>
      <input
        type="time"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.heure_fin"
        name="heure_fin"
        #heure_finCtrl="ngModel"
      />
      <div class="text-danger" *ngIf="heure_finCtrl.invalid && heure_finCtrl.touched">
        Heure fin est requise
      </div>
    </div>

    <!-- Chambre -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Chambre</label>
      <select
        class="form-select"
        disabled
        name="chambre_id"
        [(ngModel)]="itemToSave.chambre_id"
        required
        #chambre_idCtrl="ngModel"
        (change)="calculatePrice()"
      >
        <option *ngFor="let item of itemsChambre" [value]="item.id">
          {{ item.libelle }}
        </option>
      </select>
      <div class="text-danger" *ngIf="chambre_idCtrl.invalid && chambre_idCtrl.touched">
        Chambre est requise
      </div>
    </div>

    <!-- Client -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Client</label>
      <select
        class="form-select"
        disabled
        name="client_id"
        [(ngModel)]="itemToSave.client_id"
        required
        #client_idCtrl="ngModel"
      >
        <option *ngFor="let item of itemsClient" [value]="item.id">
          {{ item.nom }}/{{ item.telephone }}
        </option>
      </select>
      <div class="text-danger" *ngIf="client_idCtrl.invalid && client_idCtrl.touched">
        Client est requis
      </div>
    </div>

    <!-- Montant total -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Montant total</label>
      <input
        type="number"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.montant_total"
        name="montant_total"
        #montant_totalCtrl="ngModel"
        required
      />
      <div class="text-danger" *ngIf="montant_totalCtrl.invalid && montant_totalCtrl.touched">
        Montant total est requis
      </div>
    </div>

    <!-- Total réglé -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Total réglé</label>
      <input
        type="number"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.total_regle"
        name="total_regle"
        #total_regleCtrl="ngModel"
        required
        (input)="onCalculateMonnaie()"
      />
      <div class="text-danger" *ngIf="total_regleCtrl.invalid && total_regleCtrl.touched">
        Total réglé est requis
      </div>
    </div>

    <!-- Total ristourné -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Total ristourné</label>
      <input
        type="number"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.total_ristourne"
        name="total_ristourne"
        #total_ristourneCtrl="ngModel"
        required
        (input)="onCalculateMonnaie()"
      />
      <div class="text-danger" *ngIf="total_ristourneCtrl.invalid && total_ristourneCtrl.touched">
        Total ristourné est requis
      </div>
    </div>

    <!-- Reste à régler -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Reste à régler</label>
      <input
        type="number"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.reste_a_regler"
        name="reste_a_regler"
        #reste_a_reglerCtrl="ngModel"
        required
        (input)="onCalculateMonnaie()"
      />
      <div class="text-danger" *ngIf="reste_a_reglerCtrl.invalid && reste_a_reglerCtrl.touched">
        Reste à régler est requis
      </div>
    </div>

    <!-- Avance -->
    <div class="col-md-3 mb-3">
      <label class="form-label">Avance</label>
      <input
        type="number"
        class="form-control"
        [(ngModel)]="itemToSave.montant_avance"
        name="montant_avance"
        #montant_avanceCtrl="ngModel"
        (input)="onCalculateMonnaie()"
        required
      />
      <div class="text-danger" *ngIf="montant_avanceCtrl.invalid && montant_avanceCtrl.touched">
        Montant avance est requis
      </div>
    </div>

    <!-- Mode règlement -->
    <div class="col-md-3 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
      <label class="form-label">Mode règlement</label>
      <select
        class="form-select"
        [(ngModel)]="itemToSave.mode_reglement_id"
        name="mode_reglement_id"
        #mode_reglement_idCtrl="ngModel"
        required
      >
        <option *ngFor="let item of itemsModeReglement" [value]="item.id">{{ item.libelle }}</option>
      </select>
      <div class="text-danger" *ngIf="mode_reglement_idCtrl.invalid && mode_reglement_idCtrl.touched">
        Mode règlement est requis
      </div>
    </div>

    <!-- Caisse -->
    <div class="col-md-3 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
      <label class="form-label">Caisse</label>
      <select
        class="form-select"
        [(ngModel)]="itemToSave.caisse_id"
        name="caisse_id"
        #caisse_idCtrl="ngModel"
        required
      >
        <option *ngFor="let item of itemsUserCaisse" [value]="item.caisse_id">{{ item.caisse_libelle }}</option>
      </select>
      <div class="text-danger" *ngIf="caisse_idCtrl.invalid && caisse_idCtrl.touched">
        Caisse est requis
      </div>
    </div>

    <!-- Montant reçu -->
    <div class="col-md-3 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
      <label class="form-label">Montant reçu</label>
      <input
        type="number"
        class="form-control"
        [(ngModel)]="itemToSave.montant_recu"
        name="montant_recu"
        #montant_recuCtrl="ngModel"
        (input)="onCalculateMonnaie()"
        required
      />
      <div class="text-danger" *ngIf="montant_recuCtrl.invalid && montant_recuCtrl.touched">
        Montant reçu est requis
      </div>
    </div>

    <!-- Monnaie rendue -->
    <div class="col-md-3 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
      <label class="form-label">Monnaie rendue</label>
      <input
        type="number"
        class="form-control"
        disabled
        [(ngModel)]="itemToSave.monnaie_rendue"
        name="monnaie_rendue"
        #monnaie_rendueCtrl="ngModel"
        required
      />
      <div class="text-danger" *ngIf="monnaie_rendueCtrl.invalid && monnaie_rendueCtrl.touched">
        Monnaie rendue est requis
      </div>
    </div>

    <!-- Référence règlement -->
    <div class="col-md-3 mb-3" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
      <label class="form-label">Référence règlement</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="itemToSave.reference_reglement"
        name="reference_reglement"
        #reference_reglementCtrl="ngModel"
        required
      />
      <div class="text-danger" *ngIf="reference_reglementCtrl.invalid && reference_reglementCtrl.touched">
        Référence est requis
      </div>
    </div>

    <!-- Image upload -->
    <div class="col-md-3 mb-3">
      <div class="mb-2">
        <img
          [src]="imageDisplay || 'assets/images/default/default.avif'"
          class="w-100"
          style="height:100px; object-fit:cover;"
        />
      </div>
      <input
        hidden
        id="img"
        type="file"
        accept=".png, .jpg, .jpeg, .bmp"
        (change)="uploadFile($event)"
      />
      <label for="img" class="btn btn-primary w-100 text-white py-2">Choisir une image</label>
    </div>
  </div>

  <!-- Buttons -->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">Fermer</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Sauvegarder</button>
  </div>
</form>
